export default __webpack_public_path__ + "static/media/Gwalior-1.c1ad68ad.jpg";